import { isMoneyPositive, isMoneyZero } from '@razz-team/utils';
import { Money, MoneyProps } from './Money';

export function MoneyGrow({ value, startAdornment, ...props }: MoneyProps) {
  if (isMoneyZero(value)) {
    return <Money value={value} {...props} />;
  }

  const isGrowing = isMoneyPositive(value);

  return (
    <Money
      value={value}
      {...props}
      color={isGrowing ? 'success' : 'error'}
      startAdornment={`${isGrowing ? `▲` : `▼`} ${startAdornment ?? ''}`}
    />
  );
}
